export default __webpack_public_path__ + "16bf99540db1d312f0cf2029e352a03a.png";